import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="d-flex align-items-center gap-2">
                <span className="footer-brand">Veeper</span>
                <span className="footer-divider" />
                <span className="footer-copy">
                  &copy; {new Date().getFullYear()} Admin Panel. All rights reserved.
                </span>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-flex align-items-center justify-content-end gap-3">
                <span className="footer-version">v2.0</span>
                <span className="footer-divider" />
                <span className="footer-credit">
                  Crafted by{" "}
                  <a
                    href="https://reallifeapps.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-credit-link"
                  >
                    Real Life Apps
                  </a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
